export const COURSE_TYPE = {
  Normal: 'normal',
  Video: 'video'
}